export default __webpack_public_path__ + "static/media/business-woman.15f45621.png";